const base = `//www.dreamchimney.com/api`;
export const urlSearch = base + "/tracks/search";

export const getSearchResults = (axios, params) => {
  const query = Object.keys(params)
    .map(key => key + "=" + params[key])
    .join("&");
  return axios.get(`${urlSearch}?${query}`);
};
